import { Countertop, CountertopDocument, ElasticSearchResponse } from '@shared/services/elastic-search/models';

export const countertopsSerializer = (countertops: ElasticSearchResponse<CountertopDocument>): Countertop[] =>
  countertops.hits.hits.map((countertop) => {
    const c = countertop._source;
    return {
      image: c.field_images?.[0] ?? undefined!,
      texture: c.field_texture?.[0] ?? '',
      title: c.title?.[0] ?? '',
      dimensions: c.field_dimensions?.[0] ?? '',
    };
  });
